"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getBanners = exports.QUERY_BANNER_WITH_TRACKING = exports.QUERY_BANNER = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _client = require("./client");

var QUERY_BANNER = "\n  query GetBanners($params: BannerParamsInput, $limit: Int = 10, $after: String){\n    banners(params: $params, limit: $limit, after: $after) {\n      totalCount\n      pageInfo {\n        startCursor\n        hasNextPage\n      }\n      nodes {\n        id\n        userId\n        messageId\n        created\n        tags\n        content {\n          title\n          body\n          blocks {\n            ... on TextBlock {\n              type\n              text\n            }\n            ... on ActionBlock {\n              type\n              text\n              url\n            }\n          }\n          data\n        }\n      }\n    }\n  }\n";
exports.QUERY_BANNER = QUERY_BANNER;
var QUERY_BANNER_WITH_TRACKING = "\n  query GetBanners($params: BannerParamsInput, $limit: Int = 10, $after: String){\n    banners(params: $params, limit: $limit, after: $after) {\n      totalCount\n      pageInfo {\n        startCursor\n        hasNextPage\n      }\n      nodes {\n        id\n        userId\n        messageId\n        created\n        tags\n        content {\n          title\n          body\n          blocks {\n            ... on TextBlock {\n              type\n              text\n            }\n            ... on ActionBlock {\n              type\n              text\n              url\n            }\n          }\n          data\n          trackingIds {\n            archiveTrackingId\n          }\n        }\n      }\n    }\n  }\n";
exports.QUERY_BANNER_WITH_TRACKING = QUERY_BANNER_WITH_TRACKING;

var getBanners = function getBanners(client) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(params, after) {
      var _results$data, _results$data$banners, _results$data2, _results$data2$banner, _results$data2$banner2;

      var _ref2, limit, getTrackindIds, restParams, results, banners, startCursor;

      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (client) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", Promise.resolve(undefined));

            case 2:
              _ref2 = params !== null && params !== void 0 ? params : {}, limit = _ref2.limit, getTrackindIds = _ref2.getTrackindIds, restParams = (0, _objectWithoutProperties2["default"])(_ref2, ["limit", "getTrackindIds"]);
              _context.next = 5;
              return client.query(getTrackindIds ? QUERY_BANNER_WITH_TRACKING : QUERY_BANNER, {
                after: after,
                limit: limit,
                params: restParams
              }).toPromise();

            case 5:
              results = _context.sent;
              banners = results === null || results === void 0 ? void 0 : (_results$data = results.data) === null || _results$data === void 0 ? void 0 : (_results$data$banners = _results$data.banners) === null || _results$data$banners === void 0 ? void 0 : _results$data$banners.nodes;
              startCursor = results === null || results === void 0 ? void 0 : (_results$data2 = results.data) === null || _results$data2 === void 0 ? void 0 : (_results$data2$banner = _results$data2.banners) === null || _results$data2$banner === void 0 ? void 0 : (_results$data2$banner2 = _results$data2$banner.pageInfo) === null || _results$data2$banner2 === void 0 ? void 0 : _results$data2$banner2.startCursor;
              return _context.abrupt("return", {
                banners: banners,
                startCursor: startCursor
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.getBanners = getBanners;

var _default = function _default(params) {
  var client = (0, _client.createCourierClient)(params);
  return {
    getBanners: getBanners(client)
  };
};

exports["default"] = _default;